import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

export type Qualification = Partial<{
  id: number;
  trip_id: number;
  type: string;
  value: string | number;
  _ca: number;
  _cb: number;
  _lma: any;
  _lmb: any;
}>;

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: {
    qualificationData: {
      min_age: Qualification;
      max_age: Qualification;
      min_age_buffer: Qualification;
      max_age_buffer: Qualification;
      exclude_criminal: Qualification;
      exclude_country: Qualification;
      degree_required: Qualification;
    };
    countries: Array<{ name: string }>;
    availableCountries: Array<{ name: string }>;
  };
}>;
type QueryError = {};

const useTripQualificationsQuery = (
  tripId: number,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/qualifications`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url);
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripQualificationsQuery;
